// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__37mq4","amount":"Amount_amount__1yBjc","tip":"Amount_tip__3GhDj","tipHeader":"Amount_tipHeader__3BvoD","tipsWrap":"Amount_tipsWrap__3fWct"};